/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from '../../constants/Colors';
import {FontWeight, Text} from '../Text';
import {Breakpoints} from "../../constants/Breakpoints";

const Content = styled.div`
  width: 340px;
  float: left;
  padding-top: 0px;
  margin-bottom: 0;
  height: 100%;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-bottom: -10px;
  }
`;

const Container = styled.div`
  width: 315px;
  min-height: 100%;
  height: 100%;
  position: relative;
  background: #fff;
`;


const Logo = styled.img`
  width: 100%;
  max-height: 0;
  margin: 15px;
  padding-left: 50px;
  cursor: pointer;
  
  @media screen and (min-width: ${Breakpoints.md}) {
    max-width: 400px;    
  }

  @media screen and (min-width: ${Breakpoints.sm}) {
    width: auto;
    max-width: 100%;
    max-height: 75px;
    margin: 30px 0;
  }
`;

const Title = styled(Text)`
  font-size: 15px;
  padding-left: 55px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: ${FontWeight.SemiBold};
  color: ${Colors.GRAY[3]};
`;

const List = styled.ul`
  width: 100%;
  min-height: 200px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 20px;
  margin-bottom: -10px;
  a{
    text-decoration: none;
  }

  .active span{
    color:${Colors.BLUE};
    margin-left: 1px;
    border-left: 4px solid ${Colors.BLUE};
    background: #fff;
    border-radius: 4px;
    box-shadow: 7px 5px 16px 4px rgba(177, 175, 175, 0.19);
  }
`;

const Item = styled(Text)`
  color: ${Colors.GRAY[3]};
  font-weight: ${FontWeight.Bold};
  padding-left: 55px;
  line-height: 50px;
  height: 50px;
  display: block;
  cursor:pointer;
  i{
    color: ${Colors.BLUE};
    font-size: 27px;
    margin-right: 20px;
    float: left;
    margin-top: 10px;
  }
`;

const Settings = styled.div`
  position: absolute;
  bottom: 0;
  margin-left: 20px;
  margin-top: 40px;
  left: 0px;

  span{
    line-height: 30px;
    font-weight: ${FontWeight.Bold};
    padding-left: 35px;
    i{
      margin-top: 0px;
    }
  }
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    position: unset;
    bottom: 30px;
  }

  @media screen and (min-width: ${Breakpoints.lg}) {
    margin-top: unset;
  }

`;

const Version = styled.div`
	position: absolute;
	bottom: 0;	
	margin-left: 55px;
	padding-bottom: 50px;

	@media screen and (max-width: ${Breakpoints.sm}) {
		padding-bottom: 10px;
	}
`;

const SubTitle = styled(Text)`
  font-size: 16px;
  margin-left: 5px;
  color: ${Colors.GREEN};
  font-weight: ${FontWeight.Bold};
  opacity: 0.6;
  letter-spacing: 2px;
  margin-bottom: 20px;
  display: block;
`;

const SubTitleVersion = styled(SubTitle)`
	font-size: 14px;
	font-weight: ${FontWeight.Bold};
	line-height: 20px;
	letter-spacing: unset;
	margin: 0;
`;

const TextVersion = styled(Text)`
  font-size: 12px;
	line-height: 16px;
  letter-spacing: 1px;
  font-weight: ${FontWeight.SemiBold};
	color: ${Colors.GRAY[3]};
`;

export { Container, Logo, Title, List, Item, Settings, SubTitle, Content, Version, TextVersion, SubTitleVersion };
